"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ObjectiveName = ({ objective }) => {
    return (react_1.default.createElement("p", { className: "typography-h400 text-n-900", "data-cy": "goal-name" }, objective === null || objective === void 0 ? void 0 : objective.name));
};
exports.default = ObjectiveName;
